import { create } from "zustand";

import AdminApiCaller from "../config/api/adminapicaller";

const initialState = {
  orders: [],
  ordersCount: 0,
  isOrdersLoading: false,
  error: null,
};

export const useOrderStore = create((set) => {
  const setOrders = (partial) => set((state) => ({ ...state, ...partial }));

  return {
    ...initialState,
    getOrders: async (payload, cb) => {
      try {
        setOrders({ isOrdersLoading: true, error: null });
        const statusQuery = payload?.status ? `?status=${payload.status}` : "";
        const res = await AdminApiCaller.Get(`/get-orders${statusQuery}`);
        if (res?.status === 200) {
          setOrders({ orders: res.data.orders, isOrdersLoading: false });
        } else {
          setOrders({ isOrdersLoading: false });
        }
        if (cb) cb(res?.data);
      } catch (err) {
        setOrders({ isOrdersLoading: false, error: err });
      }
    },
    reset: () => set(initialState),
  };
});
